import { computed, inject, Injectable, Signal } from '@angular/core';
import { AppConfig } from '../../app.config';
import { createHeaders, GenericUserService, UserInfos } from '@tribeauto/ngx-mobilite-material';
import { PfAngularOauth2OidcService } from '@bnpp-pf/pf-angular-oauth2-oidc';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { urlJoin } from '../../core/helpers/url.helper';
import { AvailableSellerResponse, UserSearchRequest } from '../pages/records/records.component.model';

@Injectable({
  providedIn: 'root'
})
export class UserService extends GenericUserService {
  private readonly authService = inject(PfAngularOauth2OidcService);
  private readonly oidcUser = toSignal(this.authService.$user);
  isUserConnected: Signal<boolean> = computed(() => {
    return !!this.oidcUser();
  });

  constructor() {
    const appConfig = inject(AppConfig);
    super(appConfig.url);
  }

  updateUserLastConnectionDate(userId: number): Observable<UserInfos> {
    return this.httpClient.patch<UserInfos>(urlJoin(this.url, `${userId}/last-connection-date`), {
      headers: createHeaders()
    });
  }

  getAvailableSellers(userSearchRequest: UserSearchRequest): Observable<AvailableSellerResponse[]> {
    return this.httpClient.post<AvailableSellerResponse[]>(urlJoin(this.url, 'available-sellers'), userSearchRequest, {
      headers: createHeaders()
    });
  }
}
